<template>
  <div class="filtersContent">
    <div class="filtersScrollContainer">
      <div class="filtersTop">
        <BaseToggle
          class="w-full"
          :checked="filtersStore.isAnyFilterActive.value"
          :text="$l('showresult.filter.useSavedFilters')"
          @update:checked="filtersStore.toggleEnabled(!filtersStore.isAnyFilterActive.value)"
        />
      </div>
      <div class="filtersLayout">
        <!-- Views -->
        <div class="filtersViews">
          <component
            :is="item.component"
            v-for="(item, i) in components"
            :key="i"
            :class="{
              'filtersView--visible': componentCurrent === i
            }"
            :aria-label="item.text"
          />
        </div>
      </div>
    </div>
    <FiltersContentScrollButtons />
  </div>
</template>

<script setup>

import { l, lreplace } from '@js/utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
const filtersStore = useFiltersStore();

const componentCurrent = ref(0);
const components = [
	{
		component: 'FiltersItemPrice',
		text: l('showresult.filter.priceTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.priceTitle') }),
		icon: 'hand-cube-hand',
		propertyKeys: ['price', 'flexTicket', 'baggageIncluded', 'youthTicket', 'baggageIncluded', 'cabinBaggageIncluded', 'rebookableFlights', 'climateCompensated', 'paymentMethodIncluded']
	},
	{
		component: 'FiltersItemTransfers',
		text: l('showresult.filter.transfersTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.transfersTitle') }),
		icon: 'transfer',
		propertyKeys: ['numStops', 'changesAirport', 'airportWaitTime']
	},
	{
		component: 'FiltersItemTime',
		text: l('showresult.filter.timeTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.timeTitle') }),
		icon: 'circle-time',
		propertyKeys: ['traveltime', 'departureTime', 'arrivalTime']
	},
	{
		component: 'FiltersItemAirlines',
		text: l('showresult.filter.airlinesTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.airlinesTitle') }),
		icon: 'airlines',
		propertyKeys: ['enabledAirlines', 'blacklisted', 'alliances']
	},
	{
		component: 'FiltersItemAirports',
		text: l('global.simplePhrases.airports'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('global.simplePhrases.airports') }),
		icon: 'steering-wheel',
		propertyKeys: ['airportDepartures', 'airportArrivals', 'airportStops']
	},
	{
		component: 'FiltersItemAgencies',
		text: l('showresult.filter.travelAgencyFilterTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.travelAgencyFilterTitle') }),
		icon: 'transfer',
		propertyKeys: ['enabledAgents', 'foreign']
	},
	{
		component: 'FiltersItemSorting',
		text: l('showresult.filter.sortingFilterTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.sortingFilterTitle') }),
		icon: 'transfer',
		propertyKeys: ['numStops', 'changesAirport', 'airportWaitTime']
	}
	// {
	// 	component: 'FiltersItemTransport',
	// 	text: 'Transport',
	// 	icon: 'steering-wheel',
	// 	propertyKeys: ['excludedTravelMethods', 'excludedProducers']
	// }
	// ,...(isDevelopment ? [{ component: 'FiltersItemDeveloper', text: 'Transport', icon: 'coffee', propertyKeys: [] }] : [])
];

</script>
